import UpdateSolutionError from "./UpdateSolutionError";

export default class InvalidSolutionStateTransitionError extends UpdateSolutionError {
}
